<template>
    <div class="bill-applicable-discounts-list-popover-content">
        <ApplicableDiscountsList
            :locationId="locationId"
            :billId="billId"
            :inOperatorApp="false"
            :payUseCaseId="payUseCaseId"
            :selectedMainBillItemIds="selectedMainBillItemIds"
            @billDiscountApplied="onBillDiscountApplied"
            @onClose="() => { close(); }"
            @applyDiscountErrorOccurred="onApplyDiscountError"
        />
    </div>
</template>

<script setup lang="ts">
    import type { DaoError } from "@/data/dao/service/BaseServiceDao";
    import { onApplyDiscountErrorOccurred } from "@/data/services/DiscountsService";
    import { translations } from "@/shared/localization/translations";

    import ApplicableDiscountsList from "@/operator/components/allocation/ApplicableDiscountsList.vue";

    // define props
    const props = defineProps<{
        locationId: string;
        billId: string;
        payUseCaseId: string;
        onClose: () => void;
        selectedMainBillItemIds: string[];
    }>();

    // define html refs
    const emit = defineEmits(["close", "openBillSelected"]);

    function onBillDiscountApplied() {
        close();
    }

    function onApplyDiscountError(error: DaoError) {
        onApplyDiscountErrorOccurred(
            error,
            { containerClass: "bill-applicable-discounts-error-popup" },
            $("body"),
            translations.pay.failedNoItemsSelected
        );
    }

    function close() {
        emit("close");
        props.onClose();
    }
</script>

<style lang="scss">
    .bill-applicable-discounts-list-popover-content {
        padding: 0 0 3.5em;
    }

    .bill-applicable-discounts-list-popover-content .applicable-discount-tile {
        flex: 0 0 47% !important;
        max-width: 47% !important;
    }
</style>
